import React, { useRef, useState, useEffect } from 'react';
import { Box, Grid, TextField, Typography, Divider } from "@mui/material";


import { useSnackbar } from '../SnackBar';

import { useOrderContext } from '../../components/Context/OrderContext';

import { GoogleMap, LoadScript, Autocomplete, useJsApiLoader, Marker } from "@react-google-maps/api";
import { styled } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ConfirmDialog from '../ConfirmDialog';
import EditDialogBodyType from '../EditDialog/EditDialogBodyType';
const libraries = ["places"];

const AdminOrderView = ({  }) => {
    
    const { orderData, orderDetails } = useOrderContext(); // Use your context function

   


   
    

   

   
    
    return (

        <main id="main" className="main">
            <div className="pagetitle">
               
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/admin">Home</a></li>
                        <li className="breadcrumb-item"><a href="/Orders">Orders</a> </li>
                        <li className="breadcrumb-item active"><a href="#">Order Details</a></li>
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                
                                <div className="p-3">
                                    <h5 className="mb-3">Order Details</h5>
                                    <hr />

                                    <div className="container">
                                        {/* Order Information */}
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <strong>Order Number:</strong> <span>{orderData.orderNumber}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Status:</strong> <span>{orderData.status}</span>
                                            </div>
                                        </div>

                                        {/* Branch Details */}
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <strong>Branch Name:</strong> <span>{orderData.branch.name}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Branch Location:</strong>{" "}
                                                <span>{`${orderData.branch.city}, ${orderData.branch.state}`}</span>
                                            </div>
                                        </div>

                                        {/* Address Details */}
                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <strong>Service Address:</strong>{" "}
                                                <span>
                                                    {`${orderData.address.street}, ${orderData.address.city}, ${orderData.address.state}, ${orderData.address.zipCode}, ${orderData.address.country}`}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Car Details */}
                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <strong>Car Details:</strong>{" "}
                                                <span>
                                                    {`${orderData.carDetails.brand} ${orderData.carDetails.model} (${orderData.carDetails.year}), Reg: ${orderData.carDetails.regNumber}`}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Payment Details */}
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <strong>Total Amount:</strong> <span>{orderData.totalAmount}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Wallet Amount Used:</strong>{" "}
                                                <span>{orderData.walletAmountUsed}</span>
                                            </div>
                                        </div>

                                        {/* Service Details */}
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <strong>Service Date:</strong> <span>{orderData.serviceDate}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Time Slot:</strong> <span>{orderData.timeSlot}</span>
                                            </div>
                                        </div>

                                        {/* Additional Information */}
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <strong>Paid:</strong> <span>{orderData.isPaid ? "Yes" : "No"}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Home Service:</strong>{" "}
                                                <span>{orderData.homeService ? "Yes" : "No"}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <strong>Payment Method:</strong>{" "}
                                                <span>{orderData.paymentMethod}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="mt-3 mb-2" />
                                    <h6 className="mb-3">Order Items</h6>

                                    {/* Order Items */}
                                    <div className="container">
                                        {orderData.orderItems.map((item, index) => (
                                            <div className="row mb-2" key={index}>
                                                <div className="col-md-4">
                                                    <strong>Service Name:</strong> <span>{item.serviceName}</span>
                                                </div>
                                                <div className="col-md-2">
                                                    <strong>Quantity:</strong> <span>{item.quantity}</span>
                                                </div>
                                                <div className="col-md-2">
                                                    <strong>Price:</strong> <span>{item.price}</span>
                                                </div>
                                                <div className="col-md-2">
                                                    <strong>Tax:</strong> <span>{item.tax}</span>
                                                </div>
                                                <div className="col-md-2">
                                                    <strong>Total Price:</strong> <span>{item.totalPrice}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="p-3">
                                    <h5 className="mb-3">Order Details</h5>
                                    <hr />

                                    <div className="container">
                                        {/* Order Information */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Order Number:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{orderData.orderNumber}</span>
                                            </div>
                                        </div>

                                        {/* Branch Details */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Branch Name:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{orderData.branch.name}</span>
                                            </div>
                                        </div>

                                        {/* Payment Information */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Paid:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{orderData.isPaid ? "Yes" : "No"}</span>
                                            </div>
                                        </div>

                                        {/* Home Service */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Home Service:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{orderData.homeService ? "Yes" : "No"}</span>
                                            </div>
                                        </div>

                                        {/* Branch Location */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Branch Location:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{`${orderData.branch.city}, ${orderData.branch.state}`}</span>
                                            </div>
                                        </div>

                                        {/* Service Address */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Service Address:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{`${orderData.address.street}, ${orderData.address.city}, ${orderData.address.state}, ${orderData.address.zipCode}, ${orderData.address.country}`}</span>
                                            </div>
                                        </div>

                                        {/* Car Details */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Car Details:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{`${orderData.carDetails.brand} ${orderData.carDetails.model} (${orderData.carDetails.year}), Reg: ${orderData.carDetails.regNumber}`}</span>
                                            </div>
                                        </div>

                                        {/* Payment Details */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Total Amount:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{orderData.totalAmount}</span>
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Wallet Amount Used:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{orderData.walletAmountUsed}</span>
                                            </div>
                                        </div>

                                        {/* Service Date */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Service Date:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{orderData.serviceDate}</span>
                                            </div>
                                        </div>

                                        {/* Time Slot */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Time Slot:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{orderData.timeSlot}</span>
                                            </div>
                                        </div>

                                        {/* Payment Method */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Payment Method:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                <span>{orderData.paymentMethod}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="mt-3 mb-2" />
                                    <h6 className="mb-3">Order Items</h6>

                                    {/* Order Items */}
                                    <div className="container">
                                        {orderData.orderItems.map((item, index) => (
                                            <div className="row mb-2" key={index}>
                                                <div className="col-md-4">
                                                    <strong>Service Name:</strong>
                                                </div>
                                                <div className="col-md-8">
                                                    <span>{item.serviceName}</span>
                                                </div>
                                                <div className="col-md-4">
                                                    <strong>Quantity:</strong>
                                                </div>
                                                <div className="col-md-8">
                                                    <span>{item.quantity}</span>
                                                </div>
                                                <div className="col-md-4">
                                                    <strong>Price:</strong>
                                                </div>
                                                <div className="col-md-8">
                                                    <span>{item.price}</span>
                                                </div>
                                                <div className="col-md-4">
                                                    <strong>Tax:</strong>
                                                </div>
                                                <div className="col-md-8">
                                                    <span>{item.tax}</span>
                                                </div>
                                                <div className="col-md-4">
                                                    <strong>Total Price:</strong>
                                                </div>
                                                <div className="col-md-8">
                                                    <span>{item.totalPrice}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>


                            </div></div>  </div>


                </div>
            </section>
        </main>

    );
};


export default AdminOrderView;
